<button
	class="btn {{ btnClass }}"
	[type]="type"
	[disabled]="loading || disabled"
	[ngClass]="{
		loading: loading,
		'loading-before': loading && loadingPosition === 'before',
		'loading-after': loading && loadingPosition === 'after',
		'w-100': fillWidth
	}"
	[style.border-radius]="squareRounded ? '6px' : '100px'"
>
	<div class="btn-spinner" *ngIf="loading && loadingPosition === 'before'"></div>
	<span *ngIf="!loading || !loadingText">
		<ng-content></ng-content>
	</span>
	<span *ngIf="loading && loadingText">{{ loadingText }}</span>
	<div class="btn-spinner" *ngIf="loading && loadingPosition === 'after'"></div>
</button>
